import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import cross from "../assets/img/cross.svg";
import { useDispatch, useSelector } from "react-redux";
import TalkingPreview from "./TalkingPreview";
import { toast } from "react-toastify";
import { updateTalkingBadge } from "store/actions/talkingBadgeAction";

const VoteGetterEdit = ({ toggle, addModal, editData }) => {
  const dispatch = useDispatch();
  const { isAddLoading } = useSelector((state) => state.talkingBadges);
  const { user } = useSelector((state) => state.auth);
  const [qrCodePrice, setqrCodePrice] = useState("");
  const [showCustomPriceInput, setShowCustomPriceInput] = useState(false);

  const [formData, setFormData] = useState({
    introducingVideo: null,
    appealingVideo: null,
    amount: "0",
    athleteId: user.id,
    description: "",
  });

  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg",
      ];
      if (validImageTypes.includes(file.type)) {
        setFormData((prevData) => ({
          ...prevData,
          [fieldName]: file,
        }));
      } else {
        toast.error("Invalid file type. Please select a valid image file.");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let payload = {
      ...formData,
      amount: qrCodePrice,
      athleteID: editData?.athleteID,
      brandAmbassadorId: editData?.brandAmbassadorId,
      role: editData?.role,
      isPreview: editData?.isPreview,
    };

    await dispatch(updateTalkingBadge(editData.id, payload));
    toggle();
  };

  const data = {
    athleteImg: user.player_image.url,
    firstName: user?.first_name,
    lastName: user.last_name,
    introducingVideo: formData.introducingVideo,
    appealingVideo: formData.appealingVideo,
    editData: false,
    description: formData.description,
  };

  useEffect(() => {
    setFormData({
      introducingVideo: editData?.IntroducingImage || null,
      appealingVideo: editData?.AppealingVideo || null,
      amount: editData?.amount || "0",
      athleteId: user.id,
      description: editData?.description || "",
    });
    setqrCodePrice(editData?.amount || "");
  }, [editData]);
  return (
    <Modal isOpen={addModal} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Edit Vote Getter Badge</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <Row className="d-flex justify-content-center">
            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="appealingVideo">Add Desciption</Label>
                <Input
                  id="appealingVideo"
                  name="description"
                  type="text"
                  placeholder="Enter Description"
                  value={formData.description}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue.length <= 14) {
                      setFormData((prevData) => ({
                        ...prevData,
                        description: inputValue,
                      }));
                    } else {
                      toast.error("Only 14 characters are allowed");
                    }
                  }}
                />
              </FormGroup>
            </Col>
            <Col className="col-sm-6 col-6">
              <FormGroup>
                <Label for="exampleSelect">Online Badge Card Price</Label>
                <Input
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={qrCodePrice}
                  onChange={(e) => {
                    setqrCodePrice(Number(e.target.value));
                    if (e.target.value === "custom") {
                      setShowCustomPriceInput(true);
                    } else {
                      setShowCustomPriceInput(false);
                    }
                  }}
                >
                  <option value="">--Select Price--</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  {qrCodePrice && (
                    <option value={qrCodePrice}>{qrCodePrice}</option>
                  )}
                  <option value="custom">Custom Value</option>
                </Input>
                {showCustomPriceInput && (
                  <Input
                    className="mt-2"
                    type="number"
                    placeholder="Enter Custom Value"
                    value={qrCodePrice}
                    onChange={(e) => setqrCodePrice(Number(e.target.value))}
                    min={17}
                    max={1000}
                  />
                )}
              </FormGroup>
            </Col>
            <Col className="col-sm-6 col-6">
              <FormGroup>
                <Label for="introducingVideo">QR Code Introducing Video</Label>
                {formData.introducingVideo && (
                  <div className="position-relative">
                    <img
                      src={
                        formData.introducingVideo instanceof File
                          ? URL.createObjectURL(formData.introducingVideo)
                          : formData.introducingVideo
                      }
                      alt=""
                      className="mb-3"
                      width={80}
                      height={80}
                      required
                    />

                    <img
                      src={cross}
                      width={20}
                      alt=""
                      className="position-absolute"
                      required
                      style={{
                        top: "-11%",
                        left: "22%",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setFormData((prevData) => ({
                          ...prevData,
                          introducingVideo: null,
                        }))
                      }
                    />
                  </div>
                )}
                <Input
                  type="file"
                  accept=".jpg, .jpeg, .svg, .png"
                  onChange={(e) => handleImageChange(e, "introducingVideo")}
                />
              </FormGroup>
            </Col>
            <Col className="col-sm-6 col-6">
              <FormGroup>
                <Label for="appealingVideo">QR Code Appealing Video</Label>
                {formData.appealingVideo && (
                  <div className="position-relative">
                    <img
                      src={
                        formData.appealingVideo instanceof File
                          ? URL.createObjectURL(formData.appealingVideo)
                          : formData.appealingVideo
                      }
                      alt=""
                      className="mb-3"
                      width={80}
                      height={80}
                      required
                    />
                    <img
                      src={cross}
                      width={20}
                      alt=""
                      className="position-absolute"
                      required
                      style={{
                        top: "-11%",
                        left: "22%",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setFormData((prevData) => ({
                          ...prevData,
                          appealingVideo: null,
                        }))
                      }
                    />
                  </div>
                )}
                <Input
                  type="file"
                  accept=".jpg, .jpeg, .svg, .png"
                  onChange={(e) => handleImageChange(e, "appealingVideo")}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Button color="primary" type="submit">
              {isAddLoading ? <Spinner /> : "Update Badge"}
            </Button>
          </Row>
        </Form>
        <Row className="d-flex justify-content-center">
          <Card className="col-lg-6 col-md-8 col-sm-8 mb-3 mt-5 mx-2">
            <TalkingPreview data={data} />
          </Card>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default VoteGetterEdit;
